import {
  FETCH_PROGRESS_TESTS_PLAN_SUCCESS,
} from './actions';
import { Map } from 'immutable';
import ProgressTestsPlan from './model';
import { ApiResponseHelper } from 'omni-common-ui';

export default function sessions(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_PROGRESS_TESTS_PLAN_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  let plan = new Map({});
  let unitQuizPlanIndex = 0;
  let midtermFinalExamPlanIndex = 0;
  action.payload.forEach((planItem) => {
    const tempPlan = {
      progressReportId: planItem.unitReportId,
    };

    if (planItem.isUnitQuiz) {
      tempPlan.index = unitQuizPlanIndex;
      ++unitQuizPlanIndex;
    } else {
      tempPlan.index = midtermFinalExamPlanIndex;
      ++midtermFinalExamPlanIndex;
    }

    const planItemModel = ProgressTestsPlan.create(Object.assign(planItem, tempPlan));
    plan = plan.set(planItemModel.id, planItemModel);
  });
  return state.set(action.groupId,
    ApiResponseHelper.create({ data: plan }));
}



// WEBPACK FOOTER //
// ./data/ProgressTestsPlan/reducer.js